export function settlePromiseList(
  promises: Promise<void>[],
): Promise<{fulfilled: number; rejected: number}> {
  return Promise.allSettled(promises).then(results => {
    const fulfilled = results.filter(r => r.status === 'fulfilled').length;
    const rejected = results.filter(r => r.status === 'rejected').length;

    return {
      fulfilled,
      rejected,
    };
  });
}
